import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { useAuth } from '@morningtrain/react-auth'
import { Translation, useTranslator } from '@morningtrain/react-translations'
import moment from 'moment'
import AbortShiftExchange from 'support/actions/shifts/AbortShiftExchange'
import * as UI from 'ui'
import AvatarWrapper from 'ui/partials/AvatarWrapper'
import AcceptShiftExchange from 'support/actions/shifts/AcceptShiftExchange'
import DeclineShiftExchange from 'support/actions/shifts/DeclineShiftExchange'
import * as Displays from 'support/displays'
import RejectShiftExchange from 'support/actions/shifts/RejectShiftExchange'
import ApproveShiftExchange from 'support/actions/shifts/ApproveShiftExchange'

export default function ExchangeRequest ({
  shiftIsMine,
  shiftUserId,
  shiftCategory,
  slotId,
  initialExchangeId
}) {
  const auth = useAuth()

  const request = useValue('request') || {}
  const exchange = useValue('exchange') || {}

  const isInitialExchange = initialExchangeId === exchange.id

  const translator = useTranslator()

  const isMine = request.created_by === auth.id
  const yourId = (isMine) ? request.receiver_id : request.created_by
  const type = exchange.type

  const isMeSelling = isMine && yourId === null
  const shouldAccept = request.receiver_id === auth.id && request.status === 'created' && shiftIsMine === true
  const isPending = isMine === false
  const toMe = request.receiver_id === auth.id
  const toEverybody = request.receiver_id === null

  if (toEverybody === true) {
    // return null
  }

  const infoRows = 1
  let typeClass = exchange.type

  let aboutTitle = null

  if (type === 'exchange') {
    aboutTitle = ' vil bytte vagt'
  } else {
    // If i created it
    if (shiftIsMine === true) {
      // I did not create it
      if (toMe) {
        // It is targeted to me
        aboutTitle = ' ' + translator.trans('shiftexchange.requests.would_like_to_buy')
        typeClass = 'buy'
      } else {
        // It is not targeted to me
        aboutTitle = ' ' + translator.trans('shiftexchange.requests.is_selling_shift')
      }
    } else {
      // I did not create it
      if (toMe || toEverybody) {
        // It is targeted to me
        aboutTitle = ' ' + translator.trans('shiftexchange.requests.is_selling_shift')
      } else {
        // It is not targeted to me
        aboutTitle = ' ' + translator.trans('shiftexchange.requests.requested_to_buy')
        typeClass = 'buy'
      }
    }
  }

  function getUserShift (user_id) {
    if (typeof (exchange.seller_shift) !== 'undefined' && exchange.seller_shift !== null) {
      if (exchange.seller_shift.user_id === user_id) {
        return exchange.seller_shift
      }
    }

    if (typeof (exchange.buyer_shift) !== 'undefined' && exchange.buyer_shift !== null) {
      if (exchange.buyer_shift.user_id === user_id) {
        return exchange.buyer_shift
      }
    }

    return null
  }

  const exchangeShift = getUserShift(shiftIsMine ? yourId : request.created_by)

  let requestName = null
  let avatarUrl = null

  /* if (isMine && request.receiver_id === null && aboutTitle !== null) {
    requestName = aboutTitle[0].toUpperCase() + aboutTitle.slice(1)
    avatarUrl = request.creator.avatar_url
  } else { */
  if (isMine && request.receiver !== null) {
    requestName = request.creator.name
    avatarUrl = request.creator.avatar_url
  } else if (request.creator !== null) {
    requestName = request.creator.name
    avatarUrl = request.creator.avatar_url
  }

  if (aboutTitle !== null) {
    requestName += aboutTitle
    if (request.receiver_id !== shiftUserId && request.receiver) {
      avatarUrl = request.receiver.avatar_url
      requestName += ' ' + translator.trans('shiftexchange.generic.with') + ' ' + request.receiver.name
    }
  }
  // }

  let statusTitle = null
  let statusSlug = null

  if (!shouldAccept && !((isMine === true && request.status === 'created'))) {
    if (exchange.status === 'awaiting_approval' && request.status === 'accepted') {
      statusTitle = translator.trans('shiftexchange.status.awaiting_approval.' + shiftCategory)
      statusSlug = 'is-ok'
    } else if (request.status === 'rejected') {
      statusTitle = translator.trans('shiftexchange.status.rejected')
      statusSlug = 'is-attention'
    } else if (request.status === 'accepted') {
      statusTitle = translator.trans('shiftexchange.status.accepted')
      statusSlug = 'is-ok'
    } else if (type === 'exchange' && request.status === 'created') {
      statusTitle = translator.trans('shiftexchange.status.exchange_requested')
      if (isMine) {
        statusSlug = 'is-pending'
      }
    } else if (isMeSelling) {
      // This is my own initial request
      statusTitle = translator.trans('shiftexchange.status.for_sale')
    } else {
      switch (exchange.status) {
        case 'awaiting_approval':
          statusTitle = translator.trans('shiftexchange.status.awaiting_approval')
          break
        default:
          switch (request.status) {
            case 'rejected':
              statusTitle = translator.trans('shiftexchange.status.rejected')
              statusSlug = 'is-attention'
              break
            case 'accepted':
              statusTitle = translator.trans('shiftexchange.status.accepted')
              statusSlug = 'is-ok'
              break
            case 'created':
              statusTitle = translator.trans('shiftexchange.status.awaiting_accept')
              statusSlug = 'is-pending'
              break
          }
          break
      }
    }
  }

  return (
    <div className='request-container appointment'>

      <div className='py-4'>
        <UI.SpaceBetween align='top'>
          <AvatarWrapper>
            <img src={avatarUrl} />
          </AvatarWrapper>
          <div className='space-y-2'>
            <UI.WithSubtitle subtitle={(
              <UI.Text className='leading-none' tag='p'>
                {request.note}
              </UI.Text>
            )}
            >
              <UI.Text className='leading-none mb-2' weight='medium'>
                {requestName}
              </UI.Text>
            </UI.WithSubtitle>
            {(type === 'exchange')
              ? (
                <div className='request-time'>
                  {exchangeShift !== null
                    ? (
                      <span>
                        <span>{moment(exchangeShift.date).format('dddd Do MMMM') + ', '}</span>
                        <Displays.Time name='start_at' defaultValue={exchangeShift.start_at} />
                        <span> - </span>
                        <Displays.Time name='end_at' defaultValue={exchangeShift.end_at} />
                      </span>
                      )
                    : null}
                </div>
                )
              : null}
            <div className='request-status'>
              {isInitialExchange ? null : statusTitle}
            </div>
            <UI.ButtonWrap leftAlign>
              <AbortShiftExchange slotId={slotId} />
              <AcceptShiftExchange slotId={slotId} />
              <RejectShiftExchange slotId={slotId} />
              <ApproveShiftExchange slotId={slotId} />
              <DeclineShiftExchange slotId={slotId} />
            </UI.ButtonWrap>
          </div>
        </UI.SpaceBetween>

      </div>
    </div>
  )

  /*

        requestDom.addClass('is-' + typeClass);

        let typeIcon = document.createElement('i');
        typeIcon.addClass('material-icons');
        typeIcon.addClass('type-icon');
        requestDom.appendChild(typeIcon);

        switch (typeClass) {
            case 'exchange':
                //Two arrows
                typeIcon.innerHTML = '&#xE8D4;';
                break;
            case 'sale':
                //Arrow to the left
                typeIcon.innerHTML = '&#xE5C8;';
                typeIcon.innerHTML = '&#xE317;';
                break;
            case 'buy':
                //Arrow to the right
                typeIcon.innerHTML = '&#xE5C4;';
                typeIcon.innerHTML = '&#xE317;';
                typeIcon.addClass('flip');
                break;
        }

        // * Setup actions

        if ((isMine === true && request.status === 'created')) {

            let abortButton = document.createElement('span');
            abortButton.addClass('btn');
            abortButton.addClass('primary');
            abortButton.setAttribute('data-action', 'abort');
            abortButton.innerText = trans('shiftexchange.actions.abort');

            $(abortButton).on('click', (e) => {
                let uri = route('api.shift-exchanges.request.abort', {request_id: request.id});
                if (uri !== null) {
                    $.get(uri, (response) => {
                        console.log('Response ->', response);
                        this.refresh();
                    });
                }
            });

            requestDom.addClass('is-pending');

            requestActions.appendChild(abortButton);

        } else if (shouldAccept) {
            if (isMine === false) {

                let acceptButton = document.createElement('span');
                acceptButton.addClass('btn');
                acceptButton.addClass('primary');
                acceptButton.setAttribute('data-action', 'accept');
                acceptButton.innerText = trans('shiftexchange.actions.accept');

                $(acceptButton).on('click', (e) => {
                    let uri = route('api.shift-exchanges.request.accept', {request_id: request.id});
                    if (uri !== null) {
                        $.get(uri, (response) => {
                            console.log('Response ->', response);
                            this.refresh();
                        });
                    }
                });

                requestActions.appendChild(acceptButton);

                let declineButton = document.createElement('span');
                declineButton.addClass('btn');
                declineButton.addClass('danger');
                declineButton.setAttribute('data-action', 'decline');
                declineButton.innerText = trans('shiftexchange.actions.decline');

                $(declineButton).on('click', (e) => {
                    let uri = route('api.shift-exchanges.request.decline', {request_id: request.id});
                    if (uri !== null) {
                        $.get(uri, (response) => {
                            console.log('Response ->', response);
                            this.refresh();
                        });
                    }
                });

                requestActions.appendChild(declineButton);

            } else {

                let pendingSpan = document.createElement('span');
                pendingSpan.innerText = trans('shiftexchange.status.awaiting_accept');
                pendingSpan.addClass('request-info');
                requestActions.appendChild(pendingSpan);

            }

            requestDom.addClass('is-pending');
        }

        */
}
